// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xzuva","colBig":"styles_colBig__Afgkk","colSmall":"styles_colSmall__2T9Rv"};